var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('site-menu-title');
export var SiteMenuTitleDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    text-decoration: none;\n    font-size: ", ";\n    text-transform: uppercase;\n    font-weight: 400;\n    border-top: 1px solid ", ";\n    color: ", ";\n    margin: 0;\n    margin-top: ", ";\n    padding: ", " ", " ", ";\n  "], ["\n    text-decoration: none;\n    font-size: ", ";\n    text-transform: uppercase;\n    font-weight: 400;\n    border-top: 1px solid ", ";\n    color: ", ";\n    margin: 0;\n    margin-top: ", ";\n    padding: ", " ", " ", ";\n  "])), theme.FONT_SIZE(12), theme.COLOR('justVisible'), theme.COLOR('sub'), theme.UNIT(2, -1), theme.UNIT(2), theme.UNIT(4), theme.UNIT(1))
});
// -------- Components -------->
var My = {
  Container: styled.h3(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var SiteMenuTitle = function (props) {
  var className = props.className,
    children = props.children;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, children);
};
SiteMenuTitle.cls = cls;
SiteMenuTitle.defaultProps = SiteMenuTitleDefaultProps;
var templateObject_1, templateObject_2;